import { Theme } from "../contexts/ThemeContext";

export default function SearchIcon({ theme }: { theme: Theme }) {
    return (
        <svg
            width="24"
            height="24"
            viewBox="0 0 24 24"
            fill="none"
            xmlns="http://www.w3.org/2000/svg"
        >
            <path
                d="M11.5481 17.2559C14.7572 17.2559 17.3588 14.6547 17.3588 11.4459C17.3588 8.23719 14.7572 5.63599 11.5481 5.63599C8.33894 5.63599 5.7374 8.23719 5.7374 11.4459C5.7374 14.6547 8.33894 17.2559 11.5481 17.2559Z"
                fill={theme === "light" ? "#C6C5C5" : "#7A8690"}
                style={{
                    transition: "fill 0.3s ease",
                }}
            />
            <path
                d="M17.3751 18.407C17.8747 18.9066 18.6848 18.9066 19.1844 18.407C19.684 17.9074 19.684 17.0975 19.1844 16.5979L16.3279 13.7418C15.8283 13.2422 15.0182 13.2422 14.5186 13.7418C14.019 14.2413 14.019 15.0513 14.5186 15.5509L17.3751 18.407Z"
                fill={theme === "light" ? "#C6C5C5" : "#7A8690"}
                style={{
                    transition: "fill 0.3s ease",
                }}
            />
            <path
                d="M11.5725 14.9936C13.5135 14.9936 15.087 13.4203 15.087 11.4795C15.087 9.53875 13.5135 7.96545 11.5725 7.96545C9.6315 7.96545 8.05801 9.53875 8.05801 11.4795C8.05801 13.4203 9.6315 14.9936 11.5725 14.9936Z"
                fill={theme === "light" ? "#FFFFFF" : "#2D3748"}
                style={{
                    transition: "fill 0.3s ease",
                }}
            />
        </svg>
    );
}
